// extracted by mini-css-extract-plugin
export default {"author-card":"AuthorCard_author-card__RjrrN","title":"AuthorCard_title__ctAL5","link":"AuthorCard_link__f-ABy","description":"AuthorCard_description__1XuL7"};